require('./bootstrap');

window.bootstrap = require('bootstrap');
